<template>
<body class="hold-transition login-page">
       <div class="login-box">
  <div class="login-logo">
    <b>ownaRadio</b>
  </div>
  <!-- /.login-logo -->
  <div class="card">
    <div class="card-body login-card-body">
      <p class="login-box-msg">Reset Password</p>


<ValidationObserver ref="observer" v-slot="{invalid, passes }">
      <form @submit.prevent="passes(submit)" >
 <validation-provider name="email" rules="required|email" v-slot="{ errors }">
        <div class="input-group mb-3">
          <input name="email" v-model="form.email" type="text" class="form-control" placeholder="Email">
          <div class="input-group-append">
            <div class="input-group-text">
              <span class="fas fa-envelope"></span>
            </div>
          </div>
        </div>
        <span class="text-danger">{{ errors[0] }}</span>
 </validation-provider>

            <button :disabled="invalid || loading||!onLine" type="submit" 
            class="btn btn-info btn-block btn-flat mt-3">
            {{loading?'Loading...':'Send Password Reset Link'}}
            </button>
      </form>


</ValidationObserver>

    </div>
    <!-- /.login-card-body -->
  </div>
</div>
<!-- /.login-box -->
</body>
</template>

<script type="text/ecmascript-6">
import { mapState } from "vuex";
import { PASSWORD_EMAIL } from "@/store/action-types";

import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "ResetPassword",
  components: {
    ValidationObserver,
    ValidationProvider
  },
    computed: mapState({
    errors: (state) => state.errors,
    loading: (state) => state.loading,
    onLine: (state) => state.auth.onLine,
  }),

    data() {
        return {
            form : {
              email: '',
            },


        }
    },

 
    methods: {

        submit(){
              //We have emailed your password reset link!
              this.$store.dispatch(PASSWORD_EMAIL, this.form ).then( () => {
              // this.$router.push('/reset-password')
            }).catch( () =>  {
              this.$refs.observer.setErrors(this.errors);
            } )
 
             }
    },
    
}
</script>
